import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import customIcons from '../utils/icons';

export default function ErrorPage() {
  const error = useRouteError();
  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.data.message || error.statusText;
  } else if (error && typeof error === 'object' && 'detail' in error) {
    errorMessage = (error as { detail: string }).detail || JSON.stringify(error);
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    errorMessage = 'Unknown error';
  }

  return (
    <div id="error-boundary-page" className="flex flex-col m-auto text-center items-center w-full p-4 ">
      <span className="text-2xl m-4 text-pipstatus-alert">{customIcons.errorIcon}</span>
      <p id="error-boundary-message">{errorMessage}</p>
    </div>
  );
}
